"use client";

// src/useMutationState.ts
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { notifyManager, replaceEqualDeep } from "@tanstack/query-core";
import { useQueryClient } from "./QueryClientProvider.js";
function useIsMutating(filters, queryClient) {
  const client = useQueryClient(queryClient);
  return useMutationState({
    filters: _objectSpread(_objectSpread({}, filters), {}, {
      status: "pending"
    })
  }, client).length;
}
function getResult(mutationCache, options) {
  return mutationCache.findAll(options.filters).map(mutation => options.select ? options.select(mutation) : mutation.state);
}
function useMutationState() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let queryClient = arguments.length > 1 ? arguments[1] : undefined;
  const mutationCache = useQueryClient(queryClient).getMutationCache();
  const optionsRef = React.useRef(options);
  const result = React.useRef(null);
  if (!result.current) {
    result.current = getResult(mutationCache, options);
  }
  React.useEffect(() => {
    optionsRef.current = options;
  });
  return React.useSyncExternalStore(React.useCallback(onStoreChange => mutationCache.subscribe(() => {
    const nextResult = replaceEqualDeep(result.current, getResult(mutationCache, optionsRef.current));
    if (result.current !== nextResult) {
      result.current = nextResult;
      notifyManager.schedule(onStoreChange);
    }
  }), [mutationCache]), () => result.current, () => result.current);
}
export { useIsMutating, useMutationState };